module.exports = __webpack_public_path__ + "static/White Logo-3100ffd0aef43095e4419c342c5d7730.png";